import {LOCAL_PROP_NAME} from '../config/global';

export const getLocalProps = () => {
  try {
    const props = localStorage.getItem(LOCAL_PROP_NAME);
    return JSON.parse(props);
  } catch (e) {
    alert('You\'re using private mode. Some of the features will not be available.');
  }
};

export const setLocalProps = (props) => {
  const localProps = getLocalProps();
  const newProps = {...localProps, ...props};
  try {
    localStorage.setItem(LOCAL_PROP_NAME, JSON.stringify(newProps));
  } catch (e) {
    alert('You\'re using private mode. Some of the features will not be available.');
  }
};



// WEBPACK FOOTER //
// ./src/helpers/localStorage.js